var map = {
	"./hht2_ep18_speaking_01.png": 533,
	"./hht2_ep18_speaking_02.png": 534,
	"./hht2_ep18_speaking_03.png": 535,
	"./hht2_ep18_speaking_04.png": 536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 532;